import { type ComponentProps, type CSSProperties } from 'react';
import { type Language } from '@ev-tech/search-modules-api';

import { FormattedNumberInput } from '../FormattedNumberInput/FormattedNumberInput';

import styles from './RangeInput.module.css';

type CurrencyFormattedNumberInputProps = ComponentProps<typeof FormattedNumberInput> & {
  currencySymbol: string;
  language: Language;
};

export const CurrencyFormattedNumberInput = ({
  currencySymbol,
  language,
  startAdornment,
  endAdornment,
  ...formattedNumberInputProps
}: CurrencyFormattedNumberInputProps) => (
  <div
    className={styles.formattedNumberInput}
    data-has-start={Boolean(startAdornment)}
    style={
      {
        '--currency-padding-left': `calc(26px + ${(currencySymbol.length - 1) * 6}px)`,
      } as CSSProperties
    }
  >
    <FormattedNumberInput {...formattedNumberInputProps} endAdornment={endAdornment} language={language} startAdornment={startAdornment} />
  </div>
);
